/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Модель для организатора совместных покупок.
   */
  app.JointPurchaseOrganizer = app.Model.extend({
    urlRoot: app.entryScriptName + '/api/v3/jp-organizer',
    expand: 'expand=jp_payment_type,settlement',

    /**
     * Собирает массив с контактами организатора
     * @returns {[Array]}
     */
    prepareContactsArray: function() {
      var email = {
        type: 100,
        items: []
      };

      var settlement = {
        type: 200,
        items: []
      };

      var website = {
        type: 1,
        items: []
      };

      var phone = {
        type: 3,
        items: []
      };

      var social = {
        type: 5,
        items: []
      };

      if (this.get('email')) {
        email.items.push({ value: this.get('email') });
      }
      if (this.get('phone')) {
        phone.items.push({ value: app.helpers.PhoneHelper.getFormatedPhoneNumber(this.get('phone'))});
      }
      if (_.isArray(this.get('jpContacts'))) {
        this.get('jpContacts').forEach(function (contact) {
          switch (contact.jp_contact_type_id || contact.contact_type_id) {
            case 1:
              website.items.push({ value: contact.value});
              break;
            case 3:
              phone.items.push({ value: app.helpers.PhoneHelper.getFormatedPhoneNumber(contact.value)});
              break;
            case 5:
              social.items.push({ value: contact.value});
              break;
            case 100:
              email.items.push({ value: contact.value});
              break;
          }
        });
      }
      if (this.get('settlement_name')) {
        settlement.items.push({ value: this.get('settlement_name') });
      }

      return [email, phone, website, social, settlement];
    }
  });
})();

}.call(window));